export default __webpack_public_path__ + "static/media/bannerBoutique.13fff11d.png";